import React from 'react';
import classes from './ResourceSelection.module.scss';
import { Stack } from 'new/elements/Stack';
import { IconButton, Typography } from '@mui/material';
import { ReactComponent as DetailsIcon } from 'new/components/assets/detailsIcon.svg';
import { useResourceMeta } from 'js/hooks/useResourceMeta';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import { SelectedItemProps } from 'new/elements/ResourceSelectionButton/types';
import { ReactComponent as CloseIcon } from 'new/components/icons/close-cross.svg';
import DataSourceIcon from 'js/components/data_sources/DataSourceIcon';
import { RESOURCE_TYPE_DATA_SET, RESOURCE_TYPE_FLOW } from 'js/constants/resourceTypes';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

function SelectedItem(props: SelectedItemProps) {
  const { item, resourceType, resourceName, onClickRemove, hideDetails } = props;

  const meta = useResourceMeta(
    resourceType,
    resourceType === RESOURCE_TYPE_FLOW ? item?.data_source_id : item?.id,
  );

  const { onOpenDetailClicked } = useResourceDetailHandler();

  if (!item) return null;

  return (
    <div className={classes.selectedItemContainer}>
      <Stack
        flex={1}
        direction="row"
        alignItems="center"
        gap="16px"
        className="selected-item-stack"
      >
        <DataSourceIcon
          // @ts-ignore
          icon={meta.iconSm}
          nexset={resourceType === RESOURCE_TYPE_DATA_SET}
        />
        <Stack>
          <Typography variant="subheading">{item.name}</Typography>
          <Typography variant="bodySmall">{meta.name}</Typography>
        </Stack>
        <ChipWithCopy tooltipTitle={`Copy ${resourceName} ID`} toCopy={item.id}>
          ID {item.id}
        </ChipWithCopy>
      </Stack>
      <Stack flex={1} justifyContent="flex-end" direction="row" alignItems="center" gap="8px">
        {!hideDetails ? (
          <IconButton onClick={() => onOpenDetailClicked(item, meta)}>
            <DetailsIcon />
          </IconButton>
        ) : null}
        <IconButton onClick={onClickRemove(item)}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </div>
  );
}

export default SelectedItem;
